import React, {Component} from 'react';
import styled, {withTheme, css} from "styled-components";
import ValentinoAccademiaLogoWhite from "../icons/ValentinoAccademiaLogoWhite";
import {withRouter} from "react-router-dom";
import DropDown, {DropDownButton, DropDownItem, DropDownItemCheck, DropDownItemsList} from "../components/DropDown";
import buttonMutedStyle from "../utils/buttonMutedStyle";
import {menuItemStyle} from "../components/PageHeaderMenu";
import __ from "../utils/translatorNoLogin";
import AddToHomeIcon from '../icons/AddToHome';
import AddIcon from '../icons/AddIcon';
import IPad from "../icons/IPad";
import ArrowDownSmall from "../icons/ArrowDownSmall";
import AndroidTablet from "../icons/AndroidTablet";
import IPadMobilePortrait from "../icons/IPadMobilePortrait";
import IPadPortrait from "../icons/IPadPortrait";
import AndroidTabletPortrait from "../icons/AndroidTabletPortrait";

class AddToHome extends Component {

state = {
    isPortrait: window.innerHeight > window.innerWidth,
    isMobile: false,
    isTablet: false,
    isLanguageDropdownOpen: false,
    currentLanguage: {code: "en_UK", name: "EN"},
    currentLanguageCode: "en_UK",
    languages: [
      {code: "en_UK", name: "EN"},
      {code: "it_IT", name: "IT"},
      {code: "fr_FR", name: "FR"},
      {code: "es_ES", name: "ES"},
      {code: "pt_PT", name: "PT"},
      {code: "de_DE", name: "DE"},
      {code: "ja_JP", name: "JP"},
      {code: "ko_KR", name: "KR"},
      {code: "zh_CN", name: "CN"}
    ],
    isIOS: false,
  };


  dropdownRef = React.createRef();

  componentDidMount() {
    const isIOSDevice =
      ['iPad', 'iPhone', 'iPod'].includes(navigator.platform) ||
      (navigator.userAgent.includes("Mac") && "ontouchend" in document);

    this.setState({ isIOS: isIOSDevice });

    const ua = navigator.userAgent.toLowerCase();
    const isIPad = ua.includes('ipad');
    const isIPhone = ua.includes('iphone');
    const isAndroid = ua.includes('android');
    const isMobile = isIPhone || (isAndroid && ua.includes('mobile'));
    const isTablet = isIPad || (isAndroid && !ua.includes('mobile'));



    this.setState({
      isIOS: isIOSDevice,
      isMobile,
      isTablet: isTablet,
      isPortrait: window.innerHeight > window.innerWidth,
    });

    window.addEventListener('resize', this.handleResize);

    document.addEventListener('touchmove', this.preventScroll, { passive: false });

    document.addEventListener("mousedown", this.handleClickOutside);
    document.addEventListener("touchstart", this.handleClickOutside);

  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);

    document.removeEventListener('touchmove', this.preventScroll);
    document.removeEventListener("mousedown", this.handleClickOutside);
    document.removeEventListener("touchstart", this.handleClickOutside);

  }

  handleClickOutside = (event) => {
    if (
      this.dropdownRef.current &&
      !this.dropdownRef.current.contains(event.target)
    ) {
      this.setState({ isLanguageDropdownOpen: false });
    }
  };

  preventScroll = (e) => {
    e.preventDefault();
  };
  handleResize = () => {
    const ua = navigator.userAgent.toLowerCase();
    const isIPad = ua.includes('ipad');
    const isIPhone = ua.includes('iphone');
    const isAndroid = ua.includes('android');
    const isMobile = isIPhone || (isAndroid && ua.includes('mobile'));
    const isTablet = isIPad || (isAndroid && !ua.includes('mobile'));
    const isPortrait = window.innerHeight > window.innerWidth;

    this.setState({
      isMobile,
      isTablet: isTablet,
      isPortrait,
    });
  };


  handleLanguageChange = language => {
    localStorage.setItem("languageCode", language.code);

    this.setState({
      currentLanguage: language,
      currentLanguageCode: language.code,
    });
  };

  render() {
    return (
      <React.Fragment>
        <OverlayOver isMobile={this.state.isMobile} isPortrait={this.state.isPortrait}/>
        <PageContainer>
            <LogoContainer isMobile={this.state.isMobile} isPortrait={this.state.isPortrait}>
              <StyledValentinoAccademiaLogo />
            </LogoContainer>
          <ContentWrapper>
          <FormContainer>
                {this.state.isIOS ? (
                  <>
                    <IntroContainer isMobile={this.state.isMobile}>
                      {__('Ready to start? Add the Training App to your home screen in a few easy steps.')}
                    </IntroContainer>
                    <MessageContainer isLast={false} isMobile={this.state.isMobile} isPortrait={this.state.isPortrait}>
                      {__('Tap On')}
                      <AddToHomeIcon />
                      {__('in your browser toolbar')}
                    </MessageContainer>
                    <MessageContainer isLast={false} isMobile={this.state.isMobile} isPortrait={this.state.isPortrait}>
                      {__('Scroll through the options and choose')}
                      <AddIcon />
                      {__('“Add to Home Screen”')}
                    </MessageContainer>
                    <MessageContainer isLast={true} isMobile={this.state.isMobile} isPortrait={this.state.isPortrait}>
                      {__('Tap “Add” and the icon will appear on your Home Screen.')}
                    </MessageContainer>
                  </>
              ) : (
                <>
                  <IntroContainer isMobile={this.state.isMobile}>
                    {__('For the best experience, open this link on your iPad')}
                  </IntroContainer>
                  <MessageContainerAndroid isMobile={this.state.isMobile}>
                    {__('You\'ll be able to add the Training App directly to your Home screen, ensuring privileged and instant access to all our content.')}
                  </MessageContainerAndroid>
                </>
              )}
              </FormContainer>
            <ImageContainer isIOS={this.state.isIOS} isPortrait={this.state.isPortrait}>
              {this.state.isIOS ? (
                this.state.isMobile ? (
                  this.state.isPortrait ? (
                    <IPadMobilePortrait />
                  ) : (
                    <></>
                  )
                ) : (
                  this.state.isPortrait ? (
                    <IPadPortrait />
                  ) : (
                    <IPad />
                  )
                )
              ) : (
                this.state.isPortrait ? (
                  <AndroidTabletPortrait />
                ) : (
                  <AndroidTablet/>
                )
              )}
            </ImageContainer>
          </ContentWrapper>
          <ChangeLanguageContainer isMobile={this.state.isMobile} isPortrait={this.state.isPortrait}>
              <DropDown ref={this.dropdownRef}>
                <DropDownButton
                  style={{
                    ...buttonMutedStyle,
                    ...menuItemStyle,
                    fontSize: '0.675rem',
                    fontWeight: '400'
                  }}
                  onClick={() => this.setState({ isLanguageDropdownOpen: ! this.state.isLanguageDropdownOpen })}>
                  <ArrowDownSmall width="1.5rem" style={{ marginRight: '.25rem', }} />
                  {__(this.state.currentLanguage.name)}
                </DropDownButton>

                <DropDownItemsList
                  open={this.state.isLanguageDropdownOpen}
                  style={{
                    right: 0,
                    top: '100%',
                    backgroundColor : 'light-grey',
                }}>
                  {this.state.languages.map(language => (
                    <DropDownItem
                      key={language.code}
                      name={language.code}
                      style={{
                        fontSize: '0.675rem',
                        padding: this.state.isMobile && !this.state.isPortrait
                          ? '0.4rem 0.75rem'
                          : '0.75rem 1rem'
                      }}
                      selected={this.state.currentLanguageCode === language.code}
                      onClick={() => this.handleLanguageChange(language)} >
                      {__(language.name)}

                      <span style={{
                        paddingLeft: '.25rem',
                        visibility: this.state.currentLanguageCode === language.code ? null : 'hidden',
                      }}>
                        <DropDownItemCheck />
                      </span>
                    </DropDownItem>
                  ))}
                </DropDownItemsList>
              </DropDown>
            </ChangeLanguageContainer>
            <VersionContainer isMobile={this.state.isMobile} isPortrait={this.state.isPortrait}>
              version {process.env.REACT_APP_APP_VERSION}
            </VersionContainer>
        </PageContainer>
      </React.Fragment>
    )
  }
}

export default withRouter(withTheme(AddToHome));

const PageContainer = styled.div`
  position: absolute;
  bottom: 0;
  width:100%;
  height: 100%;
  background: #1D1D1B;
  overflow: hidden;
`;

const ContentWrapper = styled.div`
  height: calc(100% - 10rem);
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;


const LogoContainer = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  height: auto;
  padding: ${props => props.isMobile && !props.isPortrait ? '1rem' : '3rem'} 1rem;
  color: ${props => props.theme.secondaryIconColor};
`;

const StyledValentinoAccademiaLogo = styled(ValentinoAccademiaLogoWhite)`
  width: 12.5rem;
  height: 3.52125rem;
`;


const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-bottom: 1rem;
  padding: 1.5rem;
`;

const IntroContainer = styled.div`
  color: #FFFFFF;
  font-weight: 500;
  font-size: 16px;
  text-align: center;
  ${props => !props.isMobile && css`
    white-space: pre-line;
  `}
`;

const MessageContainer = styled.div`
  display:flex;
  flex-wrap: wrap;
  justify-content: center;
  color: #FAFAFA;
  font-weight: 400;
  font-size: 16px;
  padding: 1rem 0;
  border-bottom: 1px solid #404042;
  align-items: center;
  text-align: center;
  width: ${props => props.isMobile ? '83%' : '35rem'};
  margin: auto;
  ${props => !props.isMobile && props.isPortrait && css`
      padding: 2rem 2.875rem;
  `}
  margin: 0 auto;

${props => props.isLast && css`
    border-bottom: none;
`}

  > svg {
    width: 2rem;
    height: 2rem;
    margin: 0 0.5rem;
    flex-shrink: 0;
  }
`;

const MessageContainerAndroid = styled.div`
  display:flex;
  flex-direction: column;
  justify-content: center;
  color: #8B8B8B;
  font-weight: 400;
  font-size: 16px;
  padding: 1rem 0;
  align-items: center;
  text-align: center;
  width: 35rem;
  margin: 0 auto;
`;

const ChangeLanguageContainer = styled.div`
  position: absolute;
  top: ${props => props.isMobile && !props.isPortrait  ? '.875rem' : '2.875rem'};
  right: 3.5rem;
  width: 2.5rem;
  height: 1.875rem;
  color: #8B8B8B;
`;

const ImageContainer = styled.div`
  display: flex;
  justify-content: ${props => !props.isIOS && !props.isPortrait  ? 'center' : 'end'};
  align-items: end;
  width: 100%;
  height: auto;
  > svg {
    width: 73%;
    height: auto;
  }
`;

const VersionContainer = styled.div`
  position: fixed;
  display: flex;
  justify-content: center;
  width: 100%;
  bottom: 1rem;
  color: #8B8B8B;
  font-weight: 500;
  font-size: 0.75rem;
  padding: 0.5rem 2.875rem;
  align-items: center;
  height: 2rem;
  visibility: ${props => props.isMobile && !props.isPortrait  ? 'hidden' : 'visible'};
`;


const OverlayOver = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 1;
  pointer-events: none;

  ${props => !(!props.isPortrait && props.isMobile) && css`
    background: linear-gradient(
      180deg,
      rgba(0, 0, 0, 0) 0%,
      rgba(0, 0, 0, 0.1) 60%,
      rgba(0, 0, 0, 0.3) 80%,
      rgba(0, 0, 0, 0.6) 95%,
      rgba(0, 0, 0, 0.85) 100%
    );
  `}
`;

